import React from 'react';
import 'prismjs/themes/prism-tomorrow.css';
import { DiscussionEmbed } from 'disqus-react';
import './blog-post-template.scss';
import styled from 'styled-components';
import { siteAccent } from '../components/styledComponents/variables/colors';
import Date from '../components/Date';

const Section = styled.section`
  margin-top: 2rem;
  a {
    color: ${siteAccent};
    text-decoration: underline;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

const ArticleDate = styled(Date)`
  margin-bottom: 10rem;
`;

export default function Template({ data }) {
  // data.markdownRemark holds all our post data and meta data
  const { frontmatter, html } = data.markdownRemark;
  const disqusShortName = 'leejroberts';
  const disqusConfig = {
    identifier: frontmatter.id,
    title: frontmatter.title,
  };

  return [
    <article>
      <Title>{frontmatter.title}</Title>
      <ArticleDate date={frontmatter.date} />
      <Section dangerouslySetInnerHTML={{ __html: html }} />
    </article>,
    <DiscussionEmbed shortname="leejroberts-com" config={disqusConfig} />,
  ];
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/blogPostTemplate.js